import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7dae2f74&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=7dae2f74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dae2f74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dae2f74')) {
      api.createRecord('7dae2f74', component.options)
    } else {
      api.reload('7dae2f74', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7dae2f74&scoped=true&", function () {
      api.rerender('7dae2f74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/resPassword/index.vue"
export default component.exports